import React from 'react';
import styles from './textarea.module.scss';

const TextArea = React.forwardRef((props, ref) => (
  <textarea
    rows="6"
    {...props}
    className={styles.textarea}
    ref={ref}
  ></textarea>
));

export default TextArea;
